import { Button, Flex, Text, TextInput } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import cn from "classnames";
import { SubmitHandler, useForm } from "react-hook-form";
import { Form, useNavigate } from "react-router-dom";
import { appConfig } from "src/config";
import { useRedirectUrl } from "src/hooks";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { restorePasswordRequest } from "src/store/fetchers/restorePasswordRequest";

import css from "./RestorePwdPage.module.scss";

export interface IRestorePassword {
  email: string;
}
export const RestorePwdPage = () => {
  const { forwardRedirectUrl } = useRedirectUrl();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IRestorePassword>({
    mode: "onChange",
  });

  const [isLoading] = useAtom(restorePasswordRequest.isLoadingAtom);
  const onSubmit: SubmitHandler<IRestorePassword> = useAction(
    restorePasswordRequest,
  );
  return (
    <Flex className={cn(css.main, css.full)}>
      <Flex className={cn(css.main, css.mainContainer)}>
        <Flex className={css.main}>
          <appConfig.logo
            height={50}
            onClick={() => navigate(RoutesPaths.LANDING)}
            className={css.footerLogo}
          />
          <Text variant="display-1">Забыл пароль</Text>
        </Flex>
        <Form className={css.restoreForm} onSubmit={handleSubmit(onSubmit)}>
          <div className={css.restoreFormInputContainer}>
            <TextInput
              placeholder="email"
              {...register("email", {
                required: "Обязательное поле",
                pattern: {
                  value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  message: "Некорректный email",
                },
              })}
              size="xl"
              label="Почта"
              validationState={errors.email ? "invalid" : undefined}
              errorMessage={errors.email?.message}
              errorPlacement="outside"
            />
          </div>

          <Flex
            className={css.restoreFormInputContainer}
            direction={"column"}
            alignItems={"center"}
            gap={"3"}
          >
            <Button view="action" size="l" type="submit" loading={isLoading}>
              Восстановить
            </Button>
            <div
              className={css.linkLabel}
              onClick={() =>
                navigate(forwardRedirectUrl(RoutesPaths.AUTH.LOGIN))
              }
            >
              Авторизация
            </div>
          </Flex>
        </Form>
      </Flex>
    </Flex>
  );
};
